export default class ValueFormatter {
  static formatInvalidValue(value, placeholder) {
    return value === undefined || value === null ? placeholder : value;
  }
}
